// extracted by mini-css-extract-plugin
module.exports = {"upload_status":"UploadStatusComponent_upload_status__3BFsj","status_icon":"UploadStatusComponent_status_icon__3OVF9"};